import { externalData } from '@amazon/vinyl-observable'
import { globalRef, type Unsubscribe } from '@amazon/vinyl-util'
import type { LifecycleSource } from '../env/PlaybackEnv'
import { ForegroundSession } from '../metrics/foregroundSession'

function listen(target: EventTarget, type: string, callback: () => void): Unsubscribe {
    target.addEventListener(type, callback)
    return () => target.removeEventListener(type, callback)
}

// One session per page, shared by the UI and playback uploaders and sent to a native host.
const foregroundSessionRef = globalRef(() => new ForegroundSession(pageLifecycle.hidden$))

export function getPageForegroundSession(): ForegroundSession {
    return foregroundSessionRef.value
}

const isHidden = () => document.visibilityState === 'hidden'

export const pageLifecycle: LifecycleSource = {
    get hidden$() {
        return externalData(isHidden(), (setData) => {
            const sync = () => setData(isHidden())
            sync()
            return listen(document, 'visibilitychange', sync)
        })
    },
    onTerminate: (callback) => listen(window, 'pagehide', callback),
    onResume: (callback) => listen(window, 'pageshow', callback),
}
